module.exports = __webpack_public_path__ + "static/media/cta-01.973a574a.jpg";